import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appFormatPhoneNumber]'
})
export class FormatPhoneNumberDirective {

  APP_CONSTANTS = APP_CONSTANTS;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    let input = this.el.nativeElement.value;

    // Remove all non-numeric characters
    input = input.replace(/\D/g, '');

    if (input.length === 0) {
      this.el.nativeElement.value = '';
      return;
    }

    // 🇺🇸 USA FORMAT
    if (APP_CONSTANTS.COUNTRY == 'USA') {
      input = input.replace(
        /^(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})$/,
        (match, g1, g2, g3, g4) => {
          let formatted = `+${g1}`;
          if (g2) formatted += ` (${g2}`;
          if (g2.length === 3) formatted += `)`;
          if (g3) formatted += ` ${g3}`;
          if (g4) formatted += `-${g4}`;
          return formatted;
        }
      );
    }

    // 🇮🇳 INDIA FORMAT
    else if (APP_CONSTANTS.COUNTRY == 'India') {
      input = input.replace(
        /^(\d{2})(\d{0,5})(\d{0,5})$/,
        (match, g1, g2, g3) => {
          let formatted = `+${g1}`;
          if (g2) formatted += ` ${g2}`;
          if (g3) formatted += ` ${g3}`;
          return formatted;
        }
      );
    }

    // Update the input field
    this.el.nativeElement.value = input;
  }
}


// import { Directive, ElementRef, HostListener } from '@angular/core';

// @Directive({
// 	selector: '[appFormatPhoneNumber]'
// })
// export class FormatPhoneNumberDirective {

// 	constructor(private el: ElementRef) {}

// 	@HostListener('input', ['$event'])
// 	onInput(event: any): void {
// 		let input = this.el.nativeElement.value;

// 		// Remove all non-numeric characters
// 		input = input.replace(/\D/g, '');

// 		if (input.length == 0) {
// 			this.el.nativeElement.value = ''; // No input, no formatting
// 		} else if (input.length > 0) {
// 			input = input.replace(/^(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})$/, (match, g1, g2, g3, g4) => {
// 				let formatted = `+${g1}`;
// 				if (g2) formatted += ` (${g2}`;
// 				if (g2.length === 3) formatted += `)`;
// 				if (g3) formatted += ` ${g3}`;
// 				if (g4) formatted += `-${g4}`;
// 				return formatted;
// 			});
// 		}


// 		// Update the input field with the formatted value
// 		this.el.nativeElement.value = input;
// 	}

// }
